import { forwardRef, JSX, useEffect } from 'react';

import { CloseIcon } from '~components/icons/CloseIcon';
import { AssetId } from '~modules/media-library/model/Asset';
import { Button } from '~modules/media-library/view/Button';
import { JsmContactForm } from '~modules/media-library/view/JsmContactForm/JsmContactForm';

type JsmContactFormModalPanelProps = {
  onClose?: () => void;
  assetId: AssetId;
};

export const JsmContactFormModalPanel = forwardRef<
  HTMLDivElement,
  JSX.IntrinsicElements['div'] & JsmContactFormModalPanelProps
>(function JsmContactFormModal({ onClose, className, assetId, ...TheirProps }, ref) {
  const hasAssetId = Boolean(assetId);

  useEffect(() => {
    if (!hasAssetId) {
      onClose?.();
    }
  }, [hasAssetId, onClose]);

  if (!hasAssetId) return null;

  return (
    <div
      className={`ml--detail-modal--panel bg-white overflow-y-auto rounded-md shadow-xl w-full max-w-2xl max-h-lg min-h-80 max-h-full flex flex-col relative ${
        className ? className : ''
      }`}
      {...TheirProps}
      ref={ref}
    >
      <Button variant="icon" className="absolute top-0 right-0 border-none" onClick={onClose}>
        <CloseIcon />
      </Button>
      <JsmContactForm assetId={assetId} onClose={onClose} />
    </div>
  );
});
